import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface ProfileDiscoveryProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: { [flowConfig.INPUT_DATA]: string };
}

export const projectIsProfileDiscovery = (
  project: Project
): project is ProfileDiscoveryProject => project.flow === flowConfig.FLOW_NAME;
